import { render, staticRenderFns } from "./biaozhu.vue?vue&type=template&id=8e0d4510&scoped=true&"
import script from "./biaozhu.vue?vue&type=script&lang=ts&"
export * from "./biaozhu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0d4510",
  null
  
)

export default component.exports